import React from "react";
import Box from "../../component/Box/Box";
import PropTypes from "prop-types";
import Notify from "../../services/Notify";
import {ControlLabel, FormGroup} from "react-bootstrap";
import MapService from "../MapService";
import ReadpointSelector from "../../readpoint/component/ReadpointSelector";
import FormButtons from "../../component/Form/FormButtons";

class CurrentPositionForm extends React.Component {

  service = new MapService();

  constructor(props) {
    super(props);
    this.state = {};
  }

  submitForm() {
    const readpointId = this.readpointId,
        date = this.date.value;

    this.service.findLsdByReadpointAndDate(readpointId, date).then(
        (data) => {
          Notify.success('Ok');
          this.setState({result: data});
        },
        (error) => Notify.error('Falha ao salvar entidade:', error));
  }

  render() {
    const {result = {},} = this.state;

    return (
        <Box info>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>
            <ReadpointSelector
                setValue={readpointId => this.readpointId = readpointId}/>

            <FormGroup>
              <ControlLabel>Data</ControlLabel>
              <input type="text" className="form-control"
                     placeholder="Data"
                     required
                     name="date"
                     ref={
                       date => this.date = date
                     }
                     defaultValue={new Date().toISOString()}/>
            </FormGroup>

            <FormButtons history={this.props.history}/>

            <div>
              Resutlado: {JSON.stringify(result)}
            </div>
          </form>
        </Box>);
  }
}

CurrentPositionForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default CurrentPositionForm;



// WEBPACK FOOTER //
// ./src/map/currentPosition/CurrentPositionForm.js